import { useId } from 'react';

export function useIconMaskId(name: string) {
  return `${name}${useId().replace(/:/g, '')}`;
}
